import * as React from 'react'

import { HouseIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'

import QRCodeHolder from '~/client/src/desktop/components/QRCodeHolder/QRCodeHolder'
import DesktopEventStore from '~/client/src/desktop/stores/EventStore/DesktopEvents.store'
import { GenericWorkflowIcon } from '~/client/src/shared/components/WorkflowTypeIcon/WorkflowIconGroups'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { SHOW_FULLSCREEN_PREVIEW } from '~/client/src/shared/stores/EventStore/eventConstants'

import ProjectSettingsStore from '../ProjectSettings.store'
import QRsToPrint from './QRsToPrint'

interface IProps {
  store: ProjectSettingsStore
  eventsStore?: DesktopEventStore
}

const ProjectQRCodesSettings: React.FC<IProps> = observer(
  ({ store, eventsStore }) => {
    const homeFullscreenHolder = React.useRef<HTMLDivElement>(null)
    const homeFullscreenPermits = React.useRef<HTMLDivElement>(null)
    const { isWorkflowsDisabled: isFormsDisabled, isLogisticsDisabled } =
      eventsStore.appState

    const getPrintContentHome = () => {
      return homeFullscreenHolder.current
    }

    const getPrintContentPermits = () => {
      return homeFullscreenPermits.current
    }

    const setHomeRef = (element: HTMLDivElement) => {
      homeFullscreenHolder.current = element
    }

    const setFormsRef = (element: HTMLDivElement) => {
      homeFullscreenPermits.current = element
    }

    const openHomeQR = () => {
      eventsStore.dispatch(
        SHOW_FULLSCREEN_PREVIEW,
        null,
        null,
        null,
        store.homeUrl,
      )
    }

    const openPermitsQR = () => {
      eventsStore.dispatch(
        SHOW_FULLSCREEN_PREVIEW,
        null,
        null,
        null,
        store.formsUrl,
      )
    }

    return (
      <div className="setup-form-body row x-evenly">
        <QRsToPrint
          homeUrl={store.homeUrl}
          formsUrl={store.formsUrl}
          isFormsDisabled={isFormsDisabled}
          isLogisticsDisabled={isLogisticsDisabled}
          homeRef={setHomeRef}
          formsRef={setFormsRef}
        />
        {!isLogisticsDisabled && (
          <QRCodeHolder
            name={Localization.translator.struxHubHome}
            openQR={openHomeQR}
            getPrintContent={getPrintContentHome}
            url={store.homeUrl}
            icon={<HouseIcon size={24} className="tw:flex-none!" />}
          />
        )}
        {!isFormsDisabled && (
          <QRCodeHolder
            name={Localization.translator.struxHubForms}
            openQR={openPermitsQR}
            getPrintContent={getPrintContentPermits}
            url={store.formsUrl}
            icon={<GenericWorkflowIcon className="tw:flex-none!" />}
          />
        )}
      </div>
    )
  },
)

export default inject('eventsStore')(ProjectQRCodesSettings)
